import { useState } from 'react';
import { Bell, ChevronDown, LogOut } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';

export function TopBar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const display = user?.email?.split('@')[0] ?? 'account';

  return (
    <header className="flex h-16 items-center justify-end gap-5 border-b border-ink-200 bg-white px-6">
      <button
        type="button"
        className="rounded-full p-2 text-ink-500 hover:bg-ink-100"
        aria-label="Notifications"
      >
        <Bell className="h-5 w-5" />
      </button>

      <div className="hidden rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-700 sm:block">
        14 days left in trial
      </div>

      <div className="relative">
        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex items-center gap-2 rounded-md border border-ink-200 px-3 py-1.5 text-sm font-medium text-ink-900 hover:bg-ink-50"
        >
          {display}
          <ChevronDown className="h-4 w-4 text-ink-500" />
        </button>
        {menuOpen && (
          <div className="absolute right-0 mt-2 w-48 rounded-md border border-ink-200 bg-white shadow-lg">
            <button
              type="button"
              onClick={logout}
              className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-ink-700 hover:bg-ink-50"
            >
              <LogOut className="h-4 w-4" />
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
